import { useEffect, useState } from "react";
import { uniqueId } from "lodash";

export const useName = (propsName?: string) => {
  const [name, setName] = useState<string>("");

  const getUniqueName = () => {
    return `generate-name-${uniqueId()}`;
  };

  useEffect(() => {
    setName(propsName || getUniqueName());
  }, [propsName]);

  return { name };
};
